export default __webpack_public_path__ + "static/media/empty.5c6163b3.png";